import React from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { LinkContainer } from "react-router-bootstrap";
import "./App.css";
import Div100vh from "react-div-100vh";

export type NavigationStyle = "modal" | "nav";

function NavBar(props: { isAuthenticated: boolean; handleLogout: () => void }) {
  return (
    <Navbar collapseOnSelect bg="light" expand="md" className="mb-3">
      <LinkContainer to="/">
        <Navbar.Brand className="font-weight-bold text-muted">
          Conduct
        </Navbar.Brand>
      </LinkContainer>
      <Navbar.Toggle />
      <Navbar.Collapse className="justify-content-end">
        <Nav activeKey={window.location.pathname}>
          {props.isAuthenticated ? (
            <>
              <LinkContainer to="/manage">
                <Nav.Link>Manage</Nav.Link>
              </LinkContainer>
              <Nav.Link onClick={props.handleLogout}>Logout</Nav.Link>
            </>
          ) : (
            <>
              <LinkContainer to="/signup">
                <Nav.Link>Signup</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/login">
                <Nav.Link>Login</Nav.Link>
              </LinkContainer>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default function AppContainer(props: {
  isAuthenticated: boolean;
  navigationStyle: NavigationStyle;
  children?: React.ReactNode;
  handleLogout: () => void;
}) {
  const navigation =
    props.navigationStyle === "nav" ? (
      <NavBar
        isAuthenticated={props.isAuthenticated}
        handleLogout={props.handleLogout}
      />
    ) : null;
  return (
    <Div100vh className="App container py-3">
      {navigation}
      {props.children}
    </Div100vh>
  );
}
